import axios from 'axios'
import type { ApiError, ValidationError } from '../lib/api'

export function isApiError(error: unknown): error is ApiError {
  return axios.isAxiosError<ValidationError>(error)
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  if (!isApiError(error)) {
    return fallback
  }

  const data = error.response?.data
  const firstFieldError = data?.errors
    ? Object.values(data.errors).find((messages) => messages.length > 0)?.[0]
    : undefined

  return data?.message ?? firstFieldError ?? fallback
}

export function appointmentScheduleError(kind: 'lead' | 'merchant', error: unknown): string {
  if (kind === 'merchant' && apiErrorStatus(error) === 403) {
    return "You can't book appointments on this merchant"
  }
  const fieldError = apiValidationErrors(error)
  const firstFieldError = fieldError
    ? Object.values(fieldError).find((messages) => messages.length > 0)?.[0]
    : undefined
  return firstFieldError ?? apiErrorMessage(error, 'Unable to schedule the appointment.')
}

export function apiErrorStatus(error: unknown): number | undefined {
  return isApiError(error) ? error.response?.status : undefined
}

export function apiErrorCode(error: unknown): string | undefined {
  return isApiError(error) ? error.code : undefined
}

export function apiValidationErrors(error: unknown): Record<string, string[]> | undefined {
  return isApiError(error) ? error.response?.data?.errors : undefined
}

export function apiFirstValidationErrors(error: unknown): Record<string, string> | undefined {
  const errors = apiValidationErrors(error)

  if (!errors) {
    return undefined
  }

  return Object.fromEntries(
    Object.entries(errors).map(([field, messages]) => [field, messages[0] ?? 'Invalid value.']),
  )
}
